import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20 13.027s-.548.376-1.304.725c-.757.348-1.122-1.208-2.008-1.905-.913-.698-1.304-.456-1.878.134s-.861.483-1.122-.054c-.26-.536-.156.08-.756.966-.574.885-2.608 1.449-2.608 1.449-2.895.107-1.878 2.736-.705 1.958s.261-6.17.261-6.17-.365-1.02.809-1.288 2.79.08 3.26-.697c.47-.778-.26-.993.678-1.905.365-.349 1.409-.67 2.556-.295"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20 13.537a8.1 8.1 0 0 1-1.131 2.77C16.466 20.03 11.461 21.12 7.7 18.742A7.95 7.95 0 0 1 5.27 7.688c1.875-2.906 5.302-4.205 8.508-3.525"
    />
  </svg>
);
export const LanguageIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
